import React from 'react';
import { PulseLoader } from 'react-spinners';

const Spinner = () => {
  return <PulseLoader color="#787F86" size={10} />;
};

export default Spinner;
